// extracted by mini-css-extract-plugin
export default {"screen":"screen__b7c495a0","resource-btn-wrap":"resource-btn-wrap__3e534e84","arrow-right":"arrow-right__eda9617e"};